import { createModal } from "Components/Modal/helpers/createModal";

export const useTeamsModal = createModal({});
